export enum SideItemType {
  WALL_SIDE = 'Wall side',
  APPLIANCE_SIDE = 'Appliance side',
  WATERFALL = 'Waterfall edge',
  END_CAP = 'End Cap',
  END_SPLASH = 'End Splash',
}
